import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aesthetic%20overhead%20flat%20lay%20photography%20of%20artfully%20arranged%20fashion%20items%20including%20designer%20sunglasses%20a%20leather%20wallet%20a%20silk%20scarf%20and%20minimalist%20jewelry%20pieces%20scattered%20on%20a%20raw%20linen%20fabric%20backdrop%2C%20golden%20afternoon%20sunlight%20casting%20long%20soft%20shadows%2C%20warm%20amber%20and%20ivory%20color%20palette%2C%20lifestyle%20editorial%20mood%2C%20organic%20textures%2C%20sophisticated%20casual%20elegance&width=1600&height=900&seq=cta-v2-overhead-style&orientation=landscape"
          alt="Acesse o Hoobuy Sheet agora"
          title="Hoobuy Sheet Acesso Rápido"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 flex flex-col items-center gap-5 md:gap-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-wide leading-tight">
          ACESSE O HOOBUY SHEET
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-xl leading-relaxed">
          Milhares de produtos verificados esperando por você
          <br />
          Links seguros e atualizados diariamente
        </p>

        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="group mt-2 inline-flex items-center gap-0 bg-primary-500 hover:bg-primary-600 rounded-full transition-all cursor-pointer overflow-hidden"
        >
          <span className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-accent-500 rounded-full">
            <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-white">
              <i className="ri-shopping-bag-line text-lg md:text-xl"></i>
            </span>
          </span>
          <span className="px-5 md:px-7 text-sm md:text-base font-bold text-white tracking-wide whitespace-nowrap">
            BUY IT NOW
          </span>
          <span className="pr-5 md:pr-6 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-white/70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
            <i className="ri-arrow-right-up-line text-base md:text-lg"></i>
          </span>
        </a>
      </div>
    </section>
  );
}